import { Clock, FileText } from "lucide-react";
import { Badge } from "../ui/badge";

interface ExamItemsProps {
	nome: string;
	preparo: string;
	descricao: string;
}

export function ExamItems({ nome, preparo, descricao }: ExamItemsProps) {
	return (
		<div className="mb-4 rounded-xl border border-zinc-200 bg-white p-5 shadow-sm transition-all duration-200 ease-out hover:-translate-y-0.5 hover:shadow-md">
			<div className="space-y-3">
				<div className="flex items-start justify-between gap-3">
					<h3 className="text-balance text-base leading-tight font-semibold text-brand-700">
						{nome}
					</h3>
					<Badge
						variant="secondary"
						className="shrink-0 border-brand-secondary-200 bg-brand-secondary-50 text-brand-secondary-700"
					>
						<FileText className="mr-1 h-3 w-3" />
						Exame
					</Badge>
				</div>

				{descricao && (
					<p className="text-xs leading-relaxed text-zinc-600">{descricao}</p>
				)}

				<div className="flex items-start gap-2 rounded-lg border border-brand-secondary-200 bg-brand-secondary-50/70 p-3">
					<Clock className="mt-0.5 h-4 w-4 shrink-0 text-brand-secondary-500" />
					<div>
						<p className="pb-1 text-sm font-semibold text-brand-secondary-700">
							Preparo necessário:
						</p>
						<p className="text-xs text-zinc-700">
							{preparo || "Consulte nossa equipe para orientações de preparo."}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
